import { MetafieldMatchType } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ProductMetafieldState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/product-metafield";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const ProductMetafieldDetails = memo(function ProductMetafieldDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ProductMetafieldState>) {
  const invalidRegex =
    state.comparison === MetafieldMatchType.REGEX && !isValidRegex(state.value);

  const comparisonOptions: RedoListItem<MetafieldMatchType>[] = useMemo(() => {
    const matchTypeLabels = {
      [MetafieldMatchType.EXACT]: "Exact match",
      [MetafieldMatchType.CONTAINS]: "Contains",
      [MetafieldMatchType.REGEX]: "Regular expression",
    };

    return Object.values(MetafieldMatchType).map((matchType) => ({
      id: matchType,
      value: matchType,
      type: "text" as const,
      text: matchTypeLabels[matchType],
    }));
  }, []);

  const selectedComparison = state.comparison
    ? comparisonOptions.find((option) => option.value === state.comparison)
    : undefined;

  return (
    <>
      <RedoTextInput
        label="Namespace"
        setValue={(value) => setState({ ...state, namespace: value })}
        state={disabled ? "disabled" : "default"}
        value={state.namespace}
      />
      <RedoTextInput
        label="Key"
        setValue={(value) => setState({ ...state, key: value })}
        state={disabled ? "disabled" : "default"}
        value={state.key}
      />
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        flexGrow
        label="Comparison"
        options={comparisonOptions}
        optionSelected={({ item }) =>
          setState({ ...state, comparison: item.value })
        }
        placeholder="Select comparison..."
        selectedItem={selectedComparison}
        size="xs"
      />
      <RedoTextInput
        errorText={invalidRegex ? "Invalid regular expression" : undefined}
        label="Value"
        setValue={(value) => setState({ ...state, value })}
        state={disabled ? "disabled" : "default"}
        value={state.value}
      />
    </>
  );
});

function isValidRegex(pattern: string): boolean {
  try {
    new RegExp(pattern);
    return true;
  } catch {
    return false;
  }
}
